import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'dialog-messagebox-component',
    styleUrls: ['messagebox.dialogcomponent.css'],
    templateUrl: 'messagebox.dialogcomponent.html'
})
export class MessageBoxDialogComponent implements OnInit {
    title: string;
    message: string;
    oktext: string;

    constructor(private dialogRef: MatDialogRef<MessageBoxDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: BaseMessageBoxDialogOptions) {
        this.title = data.TitleText || 'Information';
        this.message = data.MessageText || '';
        this.oktext = data.OKText || 'OK';
    }

    ngOnInit() {

    }

    OKHandler() {
        this.dialogRef.close(true);
    }
}

// #region Custom Classes

export class BaseMessageBoxDialogOptions {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    IconColor?: string;
    IconName?: string;
    ShowIcon?: boolean;
    height?: string;
    width?: string;
}


// #endregion
